var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAppointments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92929 2.62073V7.50287M13.7407 2.62073V7.50287M5.44107 9.94394H8.37036M14.2289 9.94394H11.2996M5.44107 12.8732H8.37036M11.2996 12.8732H14.2289M3.97643 5.0618H15.6936C15.9525 5.0618 16.2009 5.16467 16.384 5.34779C16.5671 5.5309 16.67 5.77926 16.67 6.03823V15.8025C16.67 16.0615 16.5671 16.3098 16.384 16.4929C16.2009 16.6761 15.9525 16.7789 15.6936 16.7789H3.97643C3.71746 16.7789 3.46911 16.6761 3.28599 16.4929C3.10287 16.3098 3 16.0615 3 15.8025V6.03823C3 5.77926 3.10287 5.5309 3.28599 5.34779C3.46911 5.16467 3.71746 5.0618 3.97643 5.0618Z",
    stroke: "white",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAppointments);
export default __webpack_public_path__ + "static/media/ic-appointments.576eff46504bf9be1fbdb86fa3897d19.svg";
export { ForwardRef as ReactComponent };